import styled from 'styled-components';
import { flexbox, justifyContent, alignItems, inlineFlexbox } from '../../styles/helpers/flexbox';

const HeaderWrapper = styled.div`
  width: 100%;
  text-align: center;

  h2:last-of-type {
    margin-bottom: 10px;
  }
`;

const Heading = styled.h1`
  font-size: 22px;
  font-weight: normal;
`;

const SubHeading = styled.h2`
  font-size: 18px;
  font-weight: normal;
`;

const HeadingText = styled.h2`
  font-size: 15px;
  font-weight: normal;
  margin-top: 5px;
`;

const FlexWrapper = styled.div`
  ${flexbox()}
  ${justifyContent('space-between')}
`;

const FilterWrapper = styled.div`
  min-width: 150px;
  text-align: left;

  &:last-child {
    margin-left: auto;
  }

  label {
    font-size: 14px;
    ${flexbox()}
    ${alignItems('center')}

    div[class*='svgIconComponent--'] {
      ${flexbox()}
      ${alignItems('center')}
      margin-right: 5px;
      width: 12px;
      height: 12px;

      & > span {
        ${inlineFlexbox()}
        ${alignItems('center')}
      }

      & > span, svg {
        width: 100%;
        height: 100%;
      }

      path {
        fill: #3C4E5E !important;
      }
    }
  }
`;

const LinkWrapper = styled.div`
  position: absolute;
  right: 40px;
`;

const Link = styled.div`
  width: 130px;
  text-align: right;
  font-size: 10px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
`;

const FooterWrapper = styled.div`
  ${flexbox()}
  ${justifyContent('flex-end')}

  transform: translateY(15px);
  position: relative;

  & > div[role="button"] {
    padding: 5px 25px;

    .isvg {
      padding: 0;
      margin: 0 1ch 0 -1ch;
      height: 1em;
    }

    :first-child:not(:only-child) {
      position: absolute;
      right: 50%;
      transform: translateX(50%);
    }
  }
`;

export {
  HeaderWrapper, Heading, HeadingText, SubHeading, FlexWrapper, FilterWrapper, LinkWrapper, Link, FooterWrapper
};
